import { useRef } from 'react';
import { useDrop } from 'react-dnd';

export const DnDItemTypes = {
    CARD: 'card',
};

export const shuffleArray = (o) => {
    for(let j, x, i = o.length; i; j = Math.round(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
};

export const stylePercentToFloat = (val) => {
    return parseFloat(val.substring(0, val.length - 1));//remove %
};

export const useLocalDrop = (onDrop, refType) => {
    const ref = useRef();
    const [{canDrop}, dropTarget] = useDrop({
        accept: DnDItemTypes.CARD,
        drop(item, monitor) {
            const delta = monitor.getDifferenceFromInitialOffset();
            if (delta && ref.current) {
                const dropTargetXy = ref.current.getBoundingClientRect();
                const xStep = dropTargetXy.width / 100;
                const yStep = dropTargetXy.height / 100;

                const left = stylePercentToFloat(item.left) + (delta.x / xStep);
                const top = stylePercentToFloat(item.top) + ( delta.y / yStep );
                onDrop(item.id, left + '%', top + '%', item.open, ref.current.id, item.itemKey);
            }
        },
        canDrop(item, monitor) {
            // no turned cards allowed for selection
            return !(refType === "cardsSelection" && !item.selected && !item.open);
        },
        collect: (monitor) => ({
            canDrop: monitor.canDrop(),
        }),
    });

    if(canDrop){
        return elem => {
            ref.current = elem;
            dropTarget(ref);
        };
    } else {
        return elem => {};
    }
};